// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000000%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23000000%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* html, body {margin: 0; height: 100%; overflow: hidden} */
/* hide body scroll */
.main{
    display: flex;
}

.showtooltip {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }
  
  .hidetooltip {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
  }
  
.preference-btn {
    cursor: pointer; 
    padding-top: 4px; 
    padding-bottom: 4px; 
    padding-left: 8px; 
    padding-right: 8px; 
    border: 1px solid #1ccca0;
    border-radius: 6px; 
    font-weight: 500;
    color: #000;
    background: #fff;
    
}

.preference-btn:hover {
    cursor: pointer; 
    color: #fff;
    background: #047E35;
    border: none;
}
  

.blurhomemain {
    overflow-x: hidden;
    -moz-filter: blur(5px);
    -o-filter: blur(5px);
    -ms-filter: blur(5px);
    filter: blur(10px);
    pointer-events: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    
}

.homemain {
    overflow-x: hidden;
    
}

.showannouncepop {
    display: default
}

.hideannouncepop {
    display: none
}

.announcepopup1 {
    background-color: #ffffff; 
    margin: 0px; 
    width: 480px; 
    padding-top: 8px; 
    padding-bottom: 3px; 
    text-align: center;
}

.announcepopup2 {
    background-color: #ffffff; 
    margin: 0px; 
    width: 480px; 
    color: #696969; 
    padding-top: 5px; 
    padding-bottom: 3px; 
    text-align: center;
}

.announcepopup3 {
    background-color: #ffffff; 
    margin: 0px; 
    width: 480px; 
    color: #000000; 
    padding-top: 5px; 
    padding-bottom: 20px; 
    text-align: center;
}

.announcepopup4 {
    width: 480px; 
    height: 400px; 
    margin: 0px; 
    padding: 0px;
} 



.announcefirst {
    position: relative;
}

.AnnouncePopup {
    position: fixed;
    top: 8%;
    left: 35%;
    z-index: 1050;
    
}
.searchfilter {
    background-color: #198754;
    height: 55px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.searchfilter:hover {
    background-color: #157347;
    height: 55px;
    
}

.searchfilter:focus {
    background-color: #157347;
    height: 55px;
}

.termsandcondition {
    cursor: pointer;
}

.termsandcondition:hover {
    cursor: pointer;
    color: #0c5c48;
}

.accessheaderone {
    margin-bottom: 20px; 
    font-weight: bold; 
    font-size: 55px; 
    color: #696969;
}

.accessheaderone::after {
    content: '';
    display: block;
    background-color: #688f82;
    width: 90px;
    height: 10px;
}

.daccessheader {
    font-weight: bold; 
    color: #696969;
}

/* .daccessheader::after {
    content: '';
    display: block;
    border: 1px solid #e98181;
    width: 70px;
    height: 10px;
} */

.main-content-container {
    background-color: #F5F5F5;
    width: 100%;
    z-index: 80;    
}

.servicetagbutton {
    background-color: #047E35;
    color: #ffffff;
    width: 120px;
    padding-top: 7px;
    padding-bottom: 7px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
}

.servicetagbutton:hover {
    background-color: #07aa48;
    color: #ffffff;
    width: 120px;
    padding-top: 7px;
    padding-bottom: 7px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
}

.text-wrapper {
    text-align: center;
    position: relative;
}

.text-wrapper h3 {
    font-size: 2.5rem;
    font-weight: 500;
    /* margin-top: 2em; */
}



.text-wrapper h3 span {
    color: #156614;
}

.text-wrapper p {
    font-size: 1.5rem;
    font-weight: 400;
   
}



.search-input {
    height: 55px;
    padding-left: 20px;
    border-color: #6FD7AC;
    text-align: center;
}

  

.search-input::placeholder {
    text-align: center;
}

.search-input:placeholder-shown {
    text-align: left;
}

.searchBtn {
    background-color: #6EA6A9;
    border-color: #6EA6A9;
    color: #fff;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 80px;
    font-family: 'calibri';
}



/* ======== CARD STYLES =============*/

.card-title {
    position: relative;
}

.card-title h4 {
    font-size: 1.5rem;
    font-weight: 400;
    width: 8em;
    text-align: center;
    margin: 0 auto;
}





.figma-color {
    background: #B38AF6; 
}

.git-color {
    background: #9B59B6; 
}

.react-color {
    background: #56E5FF; 
}
.flutter-color {
    background: #005799; 
}
.elixir-color {
    background: #705582;
    background: #FF9486; 
}

.csharp-color {
    background: #A179DC; 
}
.node-color {
    background: #83CF27; 
}
.cypress-color {
    background: #6FD7AC; 
}
.prd-color {
    background: #6EA6A9; 
}
.dig-color {
    background: #36528A; 
}
.manual-color {
    background: #6B7AFD;
}

.javascript-color{
    background: #DAB92D;
}

.html-color{
    background: #EF6529;
}

.analytics-color{
    background: #27485E;
}

.findataanalytics-color{
    background: #4782D9;
}

.network-color{
    background: #13A89E;
}

.python-color{
    background: #FFDE58;
}

.sql-color{
    background: #0078D7;
}

.django-color{
    background: #092E20;
}

.card-title .title-django-rectangle{
    width: 5.3em;
    height: 2em;
    background: #092E20;
    position: absolute;
    right: 0;
    top: -2rem;
}
  
.card-title .title-sql-rectangle{
    width: 5.3em;
    height: 2em;
    background: #0078D7;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-python-rectangle{
    width: 5.3em;
    height: 2em;
    background: #FFDE58;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-findataanalytics-rectangle{
    width: 5.3em;
    height: 2em;
    background: #4782D9;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-network-rectangle{
    width: 5.3em;
    height: 2em;
    background: #13A89E;
    position: absolute;
    right: 0;
    top: -2rem;
}

.datascience-color{
    background: #7AC0C8;
} 
 

.business-color{
    background: #558AAA;
}

.fullstack-color{
    background: #DADADA;
}

.photoshop-color{
    background: #070037;
}

/* new addition */

.product-manager-training-color{
    background: #6FD7AC;
}

.technical-support-specialist-color{
    background: #6EA6A9;
}

.comphrensive-seo-specialist-color{
    background: #36528A;
}

.comphrensive-community-manager-color{
    background: #705582;
}

.cyber-color{
    background: #2BABE7;
}


.webflow-color{
    background: #4176CF;
}

.disablebtn {
    border: 1px solid #526f8b;
    background-color: #466a75;

}

.card-title .title-photoshop-rectangle{
    width: 5.3em;
    height: 2em;
    background: #070037;
    position: absolute;
    right: 0;
    top: -2rem;
}



.card-title .title-fullstack-rectangle{
    width: 5.3em;
    height: 2em;
    background: #DADADA;
    position: absolute;
    right: 0;
    top: -2rem;
}


.card-title .title-business-rectangle{
    width: 5.3em;
    height: 2em;
    background: #558AAA;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-analytics-rectangle{
    width: 5.3em;
    height: 2em;
    background: #27485E;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-datascience-rectangle{
    width: 5.3em;
    height: 2em;
    background: #7AC0C8;
    position: absolute;
    right: 0;
    top: -2rem;
}

  
.card-title .title-manual-rectangle {
    width: 5.3em;
    height: 2em;
    background: #6B7AFD;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-figma-rectangle {
    width: 5.3em;
    height: 2em;
    background: #B38AF6;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-react-rectangle {
    width: 5.3em;
    height: 2em;
    background: #56E5FF;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-flutter-rectangle {
    width: 5.3em;
    height: 2em;
    background: #005799;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-elixir-rectangle {
    width: 5.3em;
    height: 2em;
    background: #705582;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-csharp-rectangle {
    width: 5.3em;
    height: 2em;
    background: #A179DC;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-node-rectangle {
    width: 5.3em;
    height: 2em;
    background: #83CF27;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-cypress-rectangle {
    width: 5.3em;
    height: 2em;
    background: #6FD7AC;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-prd-rectangle {
    width: 5.3em;
    height: 2em;
    background: #6EA6A9;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-dig-rectangle {
    width: 5.3em;
    height: 2em;
    background: #36528A;
    position: absolute;
    right: 0;
    top: -2rem;
}


.card-title .title-git-rectangle {
    width: 5.3em;
    height: 2em;
    background: #9B59B6;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-javascript-rectangle {
    width: 5.3em;
    height: 2em;
    background: #DAB92D;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-html-rectangle {
    width: 5.3em;
    height: 2em;
    background: #EF6529;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

/* new */
.card-title .title-webflow-rectangle {
    width: 5.3em;
    height: 2em;
    background: #4176CF;
    position: absolute;
    right: 0;
    top: -2rem;
}

.card-title .title-product-manager-training-rectangle {
    width: 5.3em;
    height: 2em;
    background: #6FD7AC;
    position: absolute;
    right: 0;
    top: -2rem;
}


.card-title .title-technical-support-specialist-rectangle {
    width: 5.3em;
    height: 2em;
    background: #6EA6A9;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-comphrensive-seo-specialist-rectangle {
    width: 5.3em;
    height: 2em;
    background: #36528A;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-comphrensive-community-manager-rectangle {
    width: 5.3em;
    height: 2em;
    background: #705582;
    position: absolute;
    right: 0;
    top: -2rem;
    
}

.card-title .title-cyber-rectangle{
    width: 5.3em;
    height: 2em;
    background: #2BABE7;
    position: absolute;
    right: 0;
    top: -2rem;
}

/* end */

.card-body p {
    margin-top: 1em;
    font-size: 1.25rem;
}

.card-body .price {
    font-size: 1.5rem
}

.card-body .price span {
    font-size: 3rem;
}

.course-cards-wrapper {
    margin-top: 5em;
}

.start-btn {
    font-size: 1.5rem;
    padding: 0.8em 4em;
    border: none;
}

.up-card {
    position: relative;
    bottom: 5rem;
}

/* pagination class */
.prev {
    border: 1px solid #79bead;
    font-family: calibri;
    padding: 7px; 
    margin-right: 10px; 
    border-radius: 10px;
    color: #79bead;
    z-index: 43;
}

.nex { 
    border: 1px solid #79bead;
    font-family: calibri; 
    padding: 7px; 
    margin-left: 10px; 
    border-radius: 10px;
    color: #79bead;
    z-index: 42;
}

.academystyle {
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center; 
    vertical-align: middle; 
    margin: auto; 
    position: absolute;
    top: 0; 
    left: 0;
    bottom: 0; 
    right: 0;
    width: 100px;
    height: 70px;
}

.academystyle2 {
    align-items: center; 
    justify-content: center; 
    vertical-align: middle; 
    margin: auto; 
    
    
}


.prev:hover {
    background-color: #79bead;
    color: #fff;
    border: 1px solid #79bead;
    cursor: pointer;

    
}

.nex:hover {
    background-color: #79bead;
    color: #fff;
    border: 1px solid #79bead;
    cursor: pointer;
    
}

.footer {
    background-color: white;
    height: 410px;

}

.Naming {
    color: #156614;
    font-weight: 800;
    text-decoration: none;
}

.socialmed {
    color: #0c572b;
}

.socialmed2 {
    color: #0c572b;
    cursor: pointer;
    
}

/* .Faqtag {
    margin: 0 auto;
    text-align: center;
} */

.faqfill {
    color: #696969;
    padding-top: 25px; 
    padding-bottom: 15px; 
    padding-right: 20px; 
    font-size: 17px; 
    font-weight: 500;
}

.faqfill:hover {
    background-color: #c4e7b7;
    color: #fff

}

.Fatag::after {
    content: '';
    display: block;
    background-color: #e98181;
    width: 50px;
    height: 10px;
}


.setCenter {
    margin-top: 110px;
    margin-left: 80px;
    margin-right: 40px;
    
    
}

.topbanheight {
    height: 506px;
    background-color: #ffffff;
}

.largebig1 {
    margin-left: 7px; 
    border-radius: 40px; 
    width: 25px; 
    height: 25px; 
    background-color: #156614
}

.largebig3 {
    margin-left: 7px; 
    border-radius: 40px; 
    width: 25px; 
    height: 25px; 
    background-color: #156614
}

.largebig2 {
    height: 900px; 
    background-color: #000000
}

.works1 {
    margin-right: -100px
}

.work2 {
    margin-left: -80px
}

.works11 {
   float: right;
}

.carohei {
    height: 570px
}

.carohei2 {
    height: 700px
}

.testyspacer22 {
    margin-top: 50px
}


/* .movementicon {
    animation: t 13s linear infinite;
}

@keyframes t {
    to {
      transform: translateX(-100%);
    }
  } */



/* .movementicon {
    animation: linear infinite alternate;
    animation-name: run;
    animation-duration: 2s;
} */

/* @keyframes run {
    0% {
      right: 0%;
      transform: translateX(0);
    }
    100% {
      left: 100%;
      transform: translateX(-100%);
      
    }
} */
/* .carousel-control-prev-icon,
.carousel-control-next-icon {
  
  background-color: #79bead;
  padding: 15px;
  font-size: 12px;
  border-radius: 30px;
  
} */

.firstherotext {
    font-weight: Bold; 
    color: #103a0f; 
    /* font-size: 37px;  */
    font-family: Montserrat;
}

.secondherotext {
    margin-top: 7px; 
    margin-bottom: 25px; 
    font-weight: 500; 
    font-size: 24px; 
    color: #092b08; 
    font-family: Montserrat
}

.thirdherotext {
    margin-top: 5px; 
    font-weight: 500; 
    font-size: 30px; 
    font-family: Montserrat;
    color: #092b08; 
}

.herobtn {
    margin-top: 7px;
    font-size: 18px; 
    border-radius: 10px; 
    width: 100%; 
    border: 1px solid #156614;
    height: 52px;
    color: #047E35;
}



.contactusb {
    margin-top: 7px;
    background-color: #047E35;
    font-size: 18px; 
    border-radius: 10px; 
    width: 100%; 
    border: 1px solid #047E35;
    height: 52px;
    color: white;
}

.contactusb:hover {
    background-color: #37be6d;
    font-size: 18px; 
    border-radius: 3px; 
    width: 100%; 
    border: 1px solid #2daf2b;
    height: 52px;
    color: #ffffff;
}

.companyi {
    height: 38px
}

.taballActive {
    cursor: pointer; 
    color:#047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold;
}

.taballInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}

.tabsoftwareengineeringActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabsoftwareengineeringInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}


.tabproductdesignActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabproductdesignInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}

.tabdatascienceActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabdatascienceInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}


.tabsoftwaretestingActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabsoftwaretestingInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}

.tabcybersecurityActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabcybersecurityInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}


.tabmarketingActive {
    cursor: pointer; 
    color: #047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabmarketingInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}

.tabproductmanagementActive {
    cursor: pointer; 
    color:#047E35; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: bold
}

.tabproductmanagementInActive {
    cursor: pointer; 
    padding-top: 6px; 
    padding-bottom: 6px; 
    padding-left: 10px; 
    padding-right: 10px; 
    font-weight: 500
}


/* .testyspacer2 {
    height: 6px;
} */

.testlow {
    height: 200px; 
    background-color: #6EA6A9; 
    border-top-left-radius: 70px;
}

.testmidlow {
    position: absolute; 
    z-index: 90; 
    left: 20px; 
    bottom: 50px; 
    height: 150px; 
    width: 340px; 
    background-color: #6EA6A9; 
    border-radius: 85px
}

.testlow2 {
    height: 200px; 
    background-color: #83CF27; 
    border-top-left-radius: 70px;
}

.testmidlow2 {
    position: absolute; 
    z-index: 90; 
    left: 20px; 
    bottom: 50px; 
    height: 150px; 
    width: 340px; 
    background-color: #83CF27; 
    border-radius: 85px
}

.testlow3 {
    height: 200px; 
    background-color: #A179DC; 
    border-top-left-radius: 70px;
}

.testmidlow3 {
    position: absolute; 
    z-index: 90; 
    left: 20px; 
    bottom: 50px; 
    height: 150px; 
    width: 340px; 
    background-color: #A179DC; 
    border-radius: 85px
}
.testlow4 {
    height: 200px; 
    background-color: #005799; 
    border-top-left-radius: 70px;
}

.testmidlow4 {
    position: absolute; 
    z-index: 90; 
    left: 20px; 
    bottom: 50px; 
    height: 150px; 
    width: 340px; 
    background-color: #005799; 
    border-radius: 85px
}

.testmid {
    position: absolute; 
    z-index: 91; 
    right: 0; 
    bottom: 130px; 
    height: 130px; 
    width: 260px; 
    background-color: #ffffff;
    border-radius: 45px;
}

.testoc {
    margin-top: 5px; 
    font-size: 15px; 
    color: #ffffff;
    font-weight: 500;
}

.testname {
    margin-top: 10px; 
    font-weight: 600; 
    font-size: 20px; 
    color: #ffffff;
}

.testimg {
    border-radius: 200px; 
    height: 150px; 
    width: 160px; 
    border: 7px solid #ffffff;
    image-rendering: -moz-crisp-edges;
    /* Firefox */
    image-rendering: -o-crisp-edges;
    /* Opera */
    image-rendering: -webkit-optimize-contrast;
    /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    /* IE (non-standard property) */
}


.test1{
    height: 70px
}

.testybio {
    position: absolute; 
    right: 110px; 
    bottom: 50px; 
    z-index: 92;
}




.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}



/* disabling Company logo animations */
/* .movementicon {
    transform: translate(100%);
    animation: move 14s linear infinite;
    margin-left: auto;
    position: relative;
    width: 100%;
    top: 10px;
    right: 0;
}

@keyframes move {
    to {
      right: 100%;
      transform: translate(0);
    }
  } */


  /* add new functions for company logo */

  .movementicon{
    transition: 0.3s;
}
.movementicon:hover {
    transform: scale(1.2, 1.2);
    
}

.achcompany{
   padding-top: 11px; 
   padding-bottom: 11px; 
   margin-left: 70px;
}

.howwork {
    align-items: center; 
    justify-content: center; 
    vertical-align: middle; 
    margin: auto;  
}

.arrow1 {
    position: absolute;
    left: 22%;
    margin-top: -80px;
}

.arrow2 {
    position: absolute;
    left: 45%;
    margin-top: -80px;
}

.arrow3 {
    position: absolute;
    left: 68%;
    margin-top: -80px;
}

.headmid {
    height: 100px; 
    background-color: white;
}

.testyspacer {
    height: 48px;
}

.banimgpadsize {
    margin-left: 10px; 
    margin-right: 20px;
    position: relative;
}

.ourIntroVideo {
    background-color: #696969;
    height: 60px; 
    width: 80px; 
    border-radius: 10px; 
    cursor: pointer;
    opacity: 0.85;
}

.ourIntroVideo:hover {
    background-color: #696969;
    height: 60px; 
    width: 80px; 
    border-radius: 10px; 
    cursor: pointer;
    opacity: 1;
}

.youtubeintrovideo {
    position: absolute; 
    right: 40%; 
    top: 49%;
}
/* function ends */

.sidebarcourse {
    /* margin-top: 160px;  */
    background-color: #F5F5F5;
}

.sidebarcourse2 {
    margin-top: 160px; 
   
}

.sidebarcourse3 {
    position: absolute;
    top: 24.8% 
   
}

.sidebarcourse32 {
    position: absolute;
    top: 30% 
   
}
.unlocka {
    margin-bottom: -25px;
}

.CategoriesTab {
    display: none;
}

.showcatalogbox {
    display: block
}

.hidecatalogbox {
    display: none
}

.catalogshell {
    z-index: 91;
    position: fixed; 
    left: 0px; 
    top: 0px; 
    height: 700px; 
    width: 400px; 
    background-color: #ecf8ef;
}

.hideonfullscreen {
    display: none;
}

.servicetag {
    cursor: pointer; 
    padding-top: 4px; 
    padding-bottom: 4px; 
    padding-left: 7px; 
    padding-right: 7px; 
    border-radius: 30px; 
    font-weight: 500;
    
}

.servicetag:hover {
    cursor: pointer; 
    color: #047E35;
}

.shiftdownbar {
    position: absolute; 
    top: 100%;
}

.AllCshiftdownbar {
    position: absolute; 
    top: 35%;
}

.emptyspaces {
    height: 1680px;
}


.calendly-btn {
    color: #fff;
    padding: 10px;
    background-color: #198754;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 5px;
}
.shownocodebox {
    display: block
}

.hidenocodebox {
    display: none
}

.nocodedropdown {
    position: absolute; 
    width: 190px; 
    height: 190px; 
    background-color: #e3f8e7; 
    border: 1px solid #95beb5; 
    border-radius: 10px
}

.gggettrained {
    height: 4%;
}

.gggetjob {
    height: 1%;
}

@media (min-width: 297px) and (max-width: 322px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 3%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 302px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 302px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 302px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 302px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggetjob {
        height: 0%;
    }
    .gggettrained {
        height: 0%;
    }
    .emptyspaces {
        display: none;
    }
    /* dropdown menu is "catalogshell and cataloginnerheight"*/
    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }
   
    .youtubeintrovideo {
        position: absolute; 
        right: 40%; 
        top: 50%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }
    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    .achcompany{
        padding-top: 11px; 
        padding-bottom: 11px; 
        margin-left: 0px;
     }

    .testybio {
        position: absolute; 
        right: 50px; 
        bottom: 40px; 
        z-index: 92;
    }

    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 120px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    
    .test1{
        height: 70px
    }



    .setCenter {
        margin-top: 120px;
    }

    .topbanheight {
        height: 140vh;
        
    }

    .largebig1 {
        margin-left: 0px; 
        border-radius: 0px; 
        width: 0px; 
        height: 0px; 
    }

    .largebig2 {
        height: 0px; 
        
    }

    .works1 {
        margin-right: 0px
    }

    .work2 {
        margin-left: 0px
    }
    

    .works11 {
        margin-right: 10%;
        margin-left: 10%;
     }

    .works22 {
        margin-right: 10%;
        margin-left: 10%;
     }
    
     .carohei {
        height: 1390px;
        
    }

    .carohei2 {
        height: 1760px;
        
    }



    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .taballActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .taballInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabproductdesignActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabproductdesignInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        border-radius: 30px; 
        font-weight: 500
    }
    
    .tabdatascienceActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabdatascienceInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    
    .tabsoftwaretestingActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabsoftwaretestingInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabcybersecurityActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        border-radius: 30px;
        font-weight: Bold
    }
    
    .tabcybersecurityInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
}

@media (min-width: 323px) and (max-width: 385px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 3%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 350px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggetjob {
        height: 0%;
    }
    .gggettrained {
        height: 0%;
    }
    .emptyspaces {
        display: none;
    }
    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }
   
    .youtubeintrovideo {
        position: absolute; 
        right: 40%; 
        top: 50%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }
    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    .achcompany{
        padding-top: 11px; 
        padding-bottom: 11px; 
        margin-left: 0px;
     }

    .testybio {
        position: absolute; 
        right: 50px; 
        bottom: 40px; 
        z-index: 92;
    }

    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 120px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    
    .test1{
        height: 70px
    }



    .setCenter {
        margin-top: 120px;
    }

    .topbanheight {
        height: 140vh;
        
    }

    .largebig1 {
        margin-left: 0px; 
        border-radius: 0px; 
        width: 0px; 
        height: 0px; 
    }

    .largebig2 {
        height: 0px; 
        
    }

    .works1 {
        margin-right: 0px
    }

    .work2 {
        margin-left: 0px
    }
    

    .works11 {
        margin-right: 10%;
        margin-left: 10%;
     }

    .works22 {
        margin-right: 10%;
        margin-left: 10%;
     }
    
     .carohei {
        height: 1390px;
        
    }

    .carohei2 {
        height: 1760px;
        
    }



    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .taballActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .taballInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabproductdesignActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabproductdesignInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        border-radius: 30px; 
        font-weight: 500
    }
    
    .tabdatascienceActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabdatascienceInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    
    .tabsoftwaretestingActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabsoftwaretestingInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabcybersecurityActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        border-radius: 30px;
        font-weight: Bold
    }
    
    .tabcybersecurityInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
}



/* function ends */

@media (min-width: 380px) and (max-width: 570px){
    /* html, body {margin: 0; height: 100%; overflow: hidden} */
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 7%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 350px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 350px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggetjob {
        height: 0%;
    }

    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        display: none;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 820px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }
    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 560px;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        display: none;
        margin-top: 0px; 
        background-color: #F5F5F5;
    }

    .sidebarcourse2 {
        display: none;
        margin-top: 0px; 
        
    }
    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 40%; 
        top: 49%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    .achcompany{
        padding-top: 11px; 
        padding-bottom: 11px; 
        margin-left: 0px;
     }

    .testybio {
        position: absolute; 
        right: 50px; 
        bottom: 40px; 
        z-index: 92;
    }

    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 120px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    
    .test1{
        height: 70px
    }



    .setCenter {
        margin-top: 120px;
    }

    .topbanheight {
        height: 110vh;
        
    }

    .largebig1 {
        margin-left: 0px; 
        border-radius: 0px; 
        width: 0px; 
        height: 0px; 
    }

    .largebig2 {
        height: 0px; 
        
    }

    .works1 {
        margin-right: 0px
    }

    .work2 {
        margin-left: 0px
    }
    

    .works11 {
        margin-right: 10%;
        margin-left: 10%;
     }

    .works22 {
        margin-right: 10%;
        margin-left: 10%;
     }
    
     .carohei {
        height: 1390px;
        
    }

    .carohei2 {
        height: 1690px;
        
    }



    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .taballActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .taballInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabproductdesignActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabproductdesignInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabdatascienceActive {
        cursor: pointer; 
        color:  #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabdatascienceInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    
    .tabsoftwaretestingActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabsoftwaretestingInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabcybersecurityActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabcybersecurityInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
}


@media (min-width: 532px) and (max-width: 567px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 7%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 450px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 450px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 450px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 450px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggetjob {
        height: 0%;
    }

    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        display: none;
    }

    .bannerpreventpdown {
        height: 320px;
    }
    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }
   

    .youtubeintrovideo {
        position: absolute; 
        right: 43%; 
        top: 49%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei2 {
        height: 1400px;
    }
    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    .achcompany{
        padding-top: 11px; 
        padding-bottom: 11px; 
        margin-left: 0px;
     }

    .testybio {
        position: absolute; 
        right: 50px; 
        bottom: 40px; 
        z-index: 92;
    }

    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 120px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    
    .test1{
        height: 70px
    }



    .setCenter {
        margin-top: 120px;
    }

    .topbanheight {
        height: 130vh;
        
    }

    .largebig1 {
        margin-left: 0px; 
        border-radius: 0px; 
        width: 0px; 
        height: 0px; 
    }

    .largebig2 {
        height: 0px; 
        
    }

    .works1 {
        margin-right: 0px
    }

    .work2 {
        margin-left: 0px
    }
    

    .works11 {
        margin-right: 10%;
        margin-left: 10%;
     }

    .works22 {
        margin-right: 10%;
        margin-left: 10%;
     }
    
     .carohei {
        height: 1390px;
        
    }




    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    

    .companyi {
        height: 20px
    }


    .taballActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .taballInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500;
    }
    
    .tabproductdesignActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabproductdesignInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabdatascienceActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabdatascienceInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    
    .tabsoftwaretestingActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabsoftwaretestingInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabcybersecurityActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabcybersecurityInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
}


/* 90% screen */
@media (min-width: 1400px) and (max-width: 1590px){
    .gggetjob {
        height: 0.4%;
    }
    .gggettrained {
        height: 3.3%;
    }
    .nocodedropdown {
        position: absolute; 
        width: 240px; 
        height: 190px; 
        background-color: #e3f8e7; 
        border: 1px solid #95beb5; 
        border-radius: 10px
    }

    .sidebarcourse3{
        position: absolute;
        top: 22.3% 
    }

    .sidebarcourse32{
        position: absolute;
        top: 27.3% 
    }
    
    .AllCshiftdownbar {
        position: absolute; 
        top: 32%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 90%;
    }

    .youtubeintrovideo {  
        position: absolute; 
        right: 40%; 
        top: 49%;
    }
    
    .banimgpadsize {
        margin-left: 40px; 
        margin-right: 100px;
    }
    

    .testyspacer {
        height: 48px;
    }
    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: -80px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: -80px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: -80px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
  
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
   
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
   
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
  
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px;  
        background-color: #005799; 
        border-radius: 85px
    }
    
    
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 320px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    .carohei2 {
        height: 690px
    }
    .test1{
        height: 70px
    }
    
    .testybio {
        position: absolute; 
        right: 200px; 
        bottom: 40px; 
        z-index: 92;
    }

    
    .largebig1 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 2880px;
    }

    .largebig3 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 3780px;
    }

    .largebig2 {
        width: 4px;
    }
}


/* 80% screen */
@media (min-width: 1600px) and (max-width: 1740px){
    .gggetjob {
        height: 0%;
    }

    .gggettrained {
        height: 0%;
    }

    .nocodedropdown {
        position: absolute; 
        width: 240px; 
        height: 190px; 
        background-color: #e3f8e7; 
        border: 1px solid #95beb5; 
        border-radius: 10px
    }

    .sidebarcourse3{
        position: absolute;
        top: 20.3% 
    }

    .sidebarcourse32{
        position: absolute;
        top: 24.3% 
    }

    .AllCshiftdownbar {
        position: absolute; 
        top: 28%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 80%;
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 43%; 
        top: 47%;
    }

    .banimgpadsize {
        margin-left: 40px; 
        margin-right: 100px;
    }
    

    .testyspacer {
        height: 23px;
    }
    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: -80px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: -80px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: -80px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
  
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
   
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
   
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
  
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px;  
        background-color: #005799; 
        border-radius: 85px
    }
    
    
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 320px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    .carohei2 {
        height: 630px
    }
    .test1{
        height: 70px
    }
    
    .testybio {
        position: absolute; 
        right: 200px; 
        bottom: 40px; 
        z-index: 92;
    }

    
    .largebig1 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 2880px;
    }

    .largebig3 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 3780px;
    }

    .largebig2 {
        width: 4px;
    }
}





/* 75% screen */
@media (min-width: 1790px) and (max-width: 1890px){
    .gggetjob {
        height: 0%;
    }

    .gggettrained {
        height: 3.7%;
    }

    .nocodedropdown {
        position: absolute; 
        width: 240px; 
        height: 190px; 
        background-color: #e3f8e7; 
        border: 1px solid #95beb5; 
        border-radius: 10px
    }

    .sidebarcourse3{
        position: absolute;
        top: 18.5% 
    }

    .sidebarcourse32{
        position: absolute;
        top: 22.7% 
    }

    .AllCshiftdownbar {
        position: absolute; 
        top: 27%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 75%;
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 43%; 
        top: 47%;
    }

    .banimgpadsize {
        margin-left: 40px; 
        margin-right: 100px;
    }
    

    .testyspacer {
        height: 48px;
    }
    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: -80px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: -80px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: -80px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
  
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
   
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
   
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
  
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px;  
        background-color: #005799; 
        border-radius: 85px
    }
    
    
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 320px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    .carohei2 {
        height: 630px
    }
    .test1{
        height: 70px
    }
    
    .testybio {
        position: absolute; 
        right: 200px; 
        bottom: 40px; 
        z-index: 92;
    }

    
    .largebig1 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 2880px;
    }

    .largebig3 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 3780px;
    }

    .largebig2 {
        width: 4px;
    }
}

/* 67% screen */
@media (min-width: 1900px) and (max-width: 3000px){
    .jobgget {
        font-size: 15px;
    }
    .gggetjob {
        height: 0%;
    }
    
    .gggettrained {
        height: 0%;
    }

    .nocodedropdown {
        position: absolute; 
        width: 240px; 
        height: 190px; 
        background-color: #e3f8e7; 
        border: 1px solid #95beb5; 
        border-radius: 10px
    }

    .sidebarcourse3{
        position: absolute;
        top: 17% 
    }

    .sidebarcourse32{
        position: absolute;
        top: 20.4% 
    }

    .AllCshiftdownbar {
        position: absolute; 
        top: 26%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 67%;
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 43%; 
        top: 47%;
    }

    .banimgpadsize {
        margin-left: 40px; 
        margin-right: 100px;
    }    

    .testyspacer {
        height: 25px;
    }
    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: -80px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: -80px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: -80px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
  
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
   
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
   
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
  
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px;  
        background-color: #005799; 
        border-radius: 85px
    }
    
    
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 320px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    .carohei2 {
        height: 630px
    }
    .test1{
        height: 70px
    }
    
    .testybio {
        position: absolute; 
        right: 200px; 
        bottom: 40px; 
        z-index: 92;
    }

    
    .largebig1 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 2880px;
    }

    .largebig3 {
        margin-left: 13px; 
        border-radius: 40px; 
        width: 35px; 
        height: 35px; 
        background-color: #156614;
        position: absolute;
        top: 3780px;
    }

    .largebig2 {
        width: 4px;
    }
}


@media  (min-width: 597px) and (max-width: 870px) {
    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        display: none;
    }
    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }
    
    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 35%; 
        top: 50%;
    }
   

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei {
        height: 1490px;
        
    }

   
    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }/* your css rules for ipad portrait */
  }

@media  (min-width: 1470px) and (max-width: 1500px) {
    .gggettrained {
        height: 0%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }
    
    .carohei {
        height: 1690px;
        
    }

    .carohei2 {
        height: 600px;
        
    }


    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .arrow1 {
        position: absolute;
        left: 270px;
        margin-top: -80px;
    }
    
    .arrow2 {
        position: absolute;
        left: 570px;
        margin-top: -80px;
    }
    
    .arrow3 {
        position: absolute;
        left: 860px;
        margin-top: -80px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 330px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 330px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 330px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 330px; 
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 260px; 
        background-color: #ffffff;
        border-radius: 45px;
    }/* your css rules for ipad portrait */
  }


@media  (min-width: 1000px) and (max-width: 1150px) {
    
    .gggettrained {
        height: 0%;
    }
    
    .AllCshiftdownbar {
        position: absolute; 
        top: 48%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 53%;
    }

    .youtubeintrovideo {
        position: absolute; 
        right: 38%; 
        top: 49%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .testyspacer {
        height: 96px;
    }

    .testybio {
        position: absolute; 
        left: 20px; 
        bottom: 20px; 
        z-index: 92;
    }
    

    .headmid {
        height: 150px; 
        background-color: white;
    }
    .carohei {
        height: 1690px;
        
    }

    .carohei2 {
        height: 840px;
        
    }


    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: 0px;  
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 260px; 
        background-color: #ffffff;
        border-radius: 45px;
    }/* your css rules for ipad portrait */
  }



@media  (min-width: 1160px) and (max-width: 1350px) {
    .gggettrained {
        height: 0%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .testyspacer {
        height: 48px;
    }

    .testybio {
        position: absolute; 
        left: 20px; 
        bottom: 20px; 
        z-index: 92;
    }

    .headmid {
        height: 120px; 
        background-color: white;
    }
    .carohei {
        height: 1690px;
        
    }

    .carohei2 {
        height: 760px;
        
    }


    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }

    
    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 240px; 
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 260px; 
        background-color: #ffffff;
        border-radius: 45px;
    }/* your css rules for ipad portrait */
  }


@media (min-width: 810px) and (max-width: 900px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 20%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 550px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        display: none;
    }
    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei2 {
        height: 1050px;
        
    }

    .testyspacer {
        height: 95px;
    }
    
    .topbanheight {
        height: 645px;
        
    }

    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }


    .testybio {
        position: absolute; 
        right: 60px; 
        bottom: 20px; 
        z-index: 92;
    }
    
    
    .testlow {
        height: 220px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 220px; 
        background-color: #83CF27; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px;  
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 220px; 
        background-color: #A179DC; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 220px; 
        background-color: #005799; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 180px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
}


@media (min-width: 910px) and (max-width: 997px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 20%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 550px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        height: 1950px;
    }

    .AllCshiftdownbar {
        position: absolute; 
        top: 15%;
    }

    .shiftdownbar {
        position: absolute; 
        top: 60%;
    }
    .bannerpreventpdown {
        height: 420px;
    }
    .youtubeintrovideo {
        position: absolute; 
        right: 38%; 
        top: 49%;
    }
    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei2 {
        height: 1000px;
        
    }

    .testyspacer {
        height: 120px;
    }

    .testybio {
        position: absolute; 
        right: 60px; 
        bottom: 50px; 
        z-index: 92;
    }
    
    .topbanheight {
        height: 645px;
        
    }

    .arrow1 {
        position: absolute;
        left: 22%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 45%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 68%;
        margin-top: 90px;
        width: 0px;
        height: 0px;
    }


    
    
    
    .testlow {
        height: 220px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 220px; 
        background-color: #83CF27; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px;  
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 220px; 
        background-color: #A179DC; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 220px; 
        background-color: #005799; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 170px; 
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 180px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
}



@media (min-width: 600px) and (max-width: 800px){ 
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 15%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 550px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 550px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggettrained {
        height: 0%;
    }
    
    /* .carohei {
        height: 1690px;
        
    } */
    

    .emptyspaces {
        display: none;
    }

    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }
    
    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei2 {
        height: 1085px;
        
    }

    .testyspacer {
        height: 72px;
    }
    

    .testybio {
        position: absolute; 
        right: 40px; 
        bottom: 20px; 
        z-index: 92;
    }
    
    
    .testlow {
        height: 220px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 130px; 
        background-color: #6EA6A9; 
        border-radius: 85px
    }
    
    .testlow2 {
        height: 220px; 
        background-color: #83CF27; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 130px; 
        background-color: #83CF27; 
        border-radius: 85px
    }
    
    .testlow3 {
        height: 220px; 
        background-color: #A179DC; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 130px; 
        background-color: #A179DC; 
        border-radius: 85px
    }
    .testlow4 {
        height: 220px; 
        background-color: #005799; 
        border-top-left-radius: 50px;
    }
    
    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 50px; 
        bottom: 80px; 
        height: 150px; 
        width: 130px;
        background-color: #005799; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 170px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
}



@media (min-width: 100px) and (max-width: 293px){
    .AnnouncePopup {
        position: fixed;
        top: 8%;
        left: 3%;
        z-index: 1050;
        
    }

    .announcepopup1 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 260px; 
        padding-top: 8px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup2 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 260px; 
        color: #696969; 
        padding-top: 5px; 
        padding-bottom: 3px; 
        text-align: center;
    }
    
    .announcepopup3 {
        background-color: #ffffff; 
        margin: 0px; 
        width: 260px; 
        color: #000000; 
        padding-top: 5px; 
        padding-bottom: 20px; 
        text-align: center;
    }
    
    .announcepopup4 {
        width: 260px; 
        height: 400px; 
        margin: 0px; 
        padding: 0px;
    } 

    .gggettrained {
        height: 0%;
    }

    .emptyspaces {
        display: none;
    }

    .catalogshell {
        z-index: 91;
        position: fixed; 
        left: 0px; 
        top: 0px; 
        height: 620px; 
        width: 230px; 
        background-color: #ecf8ef;
    }
    .catalogheight{
        margin-top: 180px
    }

    .cataloginnerheight {
        overflow-x: hidden; 
        overflow-y: auto; 
        height: 360px;
    }
    .bannerpreventpdown {
        height: 320px;
    }
    .hideonfullscreen {
        display: block;
    }
    .CategoriesTab {
        display: block;
    }
    .unlocka {
        margin-bottom: 0px;
    }
    .sidebarcourse {
        margin-top: 0px; 
        background-color: #F5F5F5;
        display: none
    }

    .sidebarcourse2 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse3 {
        margin-top: 0px; 
        display: none
    }

    .sidebarcourse32 {
        margin-top: 0px; 
        display: none
    }
    
    .unlocka {
        margin-bottom: 0px;
    }
   
    .youtubeintrovideo {
        position: absolute; 
        right: 35%; 
        top: 50%;
    }

    .banimgpadsize {
        margin-left: 10px; 
        margin-right: 10px;
    }

    .carohei2 {
        height: 2195px;
        
    }
    .topbanheight {
        height: 1145px;
        
    }
    .arrow1 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow2 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    
    .arrow3 {
        position: absolute;
        left: 0px;
        margin-top: 0px;
        width: 0px;
        height: 0px;
    }
    .achcompany{
        padding-top: 11px; 
        padding-bottom: 11px; 
        margin-left: 0px;
     }

    .testybio {
        position: absolute; 
        right: 10px; 
        bottom: 40px; 
        z-index: 92;
    }

    .testlow {
        height: 200px; 
        background-color: #6EA6A9; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow2 {
        height: 200px; 
        background-color: #83CF27; 
        border-top-left-radius: 70px;
    }
    
    
    
    .testlow3 {
        height: 200px; 
        background-color: #A179DC; 
        border-top-left-radius: 70px;
    }
    .testlow4 {
        height: 200px; 
        background-color: #005799; 
        border-top-left-radius: 70px;
    }
    
    .testmidlow {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow2 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow3 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }

    .testmidlow4 {
        position: absolute; 
        z-index: 90; 
        left: 20px; 
        bottom: 50px; 
        height: 150px; 
        width: 310px; 
        background-color: #0000ff00; 
        border-radius: 85px
    }
    
    .testmid {
        position: absolute; 
        z-index: 91; 
        right: 0; 
        bottom: 130px; 
        height: 130px; 
        width: 120px; 
        background-color: #ffffff;
        border-radius: 45px;
    }
    
    .testoc {
        margin-top: 5px; 
        font-size: 15px; 
        color: #ffffff;
        font-weight: 500;
    }
    
    .testname {
        margin-top: 10px; 
        font-weight: 600; 
        font-size: 20px; 
        color: #ffffff;
    }
    
    .testimg {
        border-radius: 200px; 
        height: 170px; 
        width: 180px; 
        border: 7px solid #ffffff 
    }
    
    
    .test1{
        height: 70px
    }



    .setCenter {
        margin-top: 120px;
    }

   

    .largebig1 {
        margin-left: 0px; 
        border-radius: 0px; 
        width: 0px; 
        height: 0px; 
    }

    .largebig2 {
        height: 0px; 
        
    }

    .works1 {
        margin-right: 0px
    }

    .work2 {
        margin-left: 0px
    }
    

    .works11 {
        margin-right: 10%;
        margin-left: 10%;
     }

    .works22 {
        margin-right: 10%;
        margin-left: 10%;
     }
    
     .carohei {
        height: 1390px;
        
    }

   
    



    .firstherotext {
        font-size: 27px; 
    
        
    }
    
    .secondherotext {
        font-size: 19px; 
        
    }
    
    .thirdherotext {
        font-size: 19px; 
        
    }
    
    .herobtn {
        font-size: 17px; 
        
    }

    .contactusb {
        margin-top: 7px;
        font-size: 17px; 
        
    }

    .companyi {
        height: 20px
    }


    .taballActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .taballInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabproductdesignActive {
        cursor: pointer; 
        background-color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabproductdesignInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabdatascienceActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabdatascienceInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    
    .tabsoftwaretestingActive {
        cursor: pointer; 
        color: #047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabsoftwaretestingInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
    
    .tabcybersecurityActive {
        cursor: pointer; 
        color:#047E35; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: Bold
    }
    
    .tabcybersecurityInActive {
        cursor: pointer; 
        padding-top: 4px; 
        padding-bottom: 4px; 
        padding-left: 7px; 
        padding-right: 7px; 
        font-weight: 500
    }
}

.flip-card {
    /* Existing styles for the main container */
    position: relative; /* Required for absolute positioning */
  }
  
  .flip-card-front {
    /* Existing styles for the front image and content */
    /* z-index: 1; */
    transform: rotateY(0deg);  /* Set initial rotation for front */
  transition: transform 0.5s ease-in-out; /* Add transition for flipping */
  }
  
  .flip-card-back {
    /* Existing styles for the back image and content */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.5s ease-in-out;  /* Adds smooth transition effect */
    opacity: 0; /* Initially hide the back content */
    transform: rotateY(-180deg);  /* Set initial rotation for back (opposite) */
  }
  .flip-card:hover .flip-card-front {
    transform: rotateY(180deg); /* Flip front on hover */
  }
  
  .flip-card:hover .flip-card-back {
    transform: rotateY(0deg);
    opacity: 1; /* Reveal back content on hover */
  }
 
  
  @media (max-width: 1200px){
    .tes {
        justify-content: center;
    }
  }
  
 @media (max-width: 1150px){
    .adjust{
        margin-top: 90px;
    }
 }
 
 @media (max-width: 999px){
    .adjust{
        margin-top: -60px;
    }
 }
 
 
 @media (max-width: 991px){
    .adjust{
        margin-bottom: 90px;
    }
 }

@media (max-width: 500px){
    .adjust{
        margin-bottom: 170px;
    }
}

@media (max-width: 455px){
    .adjust{
        margin-bottom: 200px;
    }
}

@media (max-width:400px){
    .adjust{
        margin-bottom: 320px;
        
    }
}

@media (max-width:350px){
    .adjust{
        margin-bottom: 450px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/main.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D,qBAAqB;AACrB;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,oCAAoC;IACpC,oBAAoB;EACtB;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAElB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;;;AAIA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,aAAa;;AAEjB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;;;;;GAMG;;AAEH;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;;;AAIA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;;AAEpB;;;;AAIA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;;;AAIA,sCAAsC;;AAEtC;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;;;;;AAMA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IAInB,mBAAmB;AAHvB;;AAMA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;;AAEjB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;;AAE7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;;AAIA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA,QAAQ;AACR;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA,QAAQ;;AAER;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;;;AAGhB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,eAAe;;;AAGnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;;AAEjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;;AAEnB;;AAEA;;;GAGG;;AAEH;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB;;AAEJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;;;AAGtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;GACG,YAAY;AACf;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;;;;;;;;KAQK;;;;AAIL;;;;GAIG;;AAEH;;;;;;;;;;GAUG;AACH;;;;;;;;GAQG;;AAEH;IACI,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;;;AAIA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;;AAGA;;GAEG;;AAEH;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB;AACJ;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,aAAa;IACb,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,YAAY;IACZ,+BAA+B;IAC/B,UAAU;IACV,0CAA0C;IAC1C,iCAAiC;IACjC,4BAA4B;IAC5B,wCAAwC;IACxC,+BAA+B;AACnC;;;AAGA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;;;;AAKA;IACI,oEAA8N;AAClO;;AAEA;IACI,oEAA8N;AAClO;;;;AAIA,sCAAsC;AACtC;;;;;;;;;;;;;;;KAeK;;;EAGH,uCAAuC;;EAEvC;IACE,gBAAgB;AACpB;AACA;IACI,0BAA0B;;AAE9B;;AAEA;GACG,iBAAiB;GACjB,oBAAoB;GACpB,iBAAiB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA,kBAAkB;;AAElB;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB;;AAEJ;;AAEA;IACI,kBAAkB;IAClB;;AAEJ;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA,0DAA0D;IAC1D;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;KACnB;;IAED;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;;IAGA;QACI;IACJ;;;;IAIA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;IAED;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;KAEA;QACG,cAAc;;IAElB;;IAEA;QACI,cAAc;;IAElB;;;;IAIA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;KACnB;;IAED;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;;IAGA;QACI;IACJ;;;;IAIA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;IAED;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;KAEA;QACG,cAAc;;IAElB;;IAEA;QACI,cAAc;;IAElB;;;;IAIA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;;;AAIA,kBAAkB;;AAElB;IACI,2DAA2D;IAC3D;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,eAAe;;IAEnB;IACA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;KACnB;;IAED;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;;IAGA;QACI;IACJ;;;;IAIA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;IAED;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;KAEA;QACG,cAAc;;IAElB;;IAEA;QACI,cAAc;;IAElB;;;;IAIA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;;IAGA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;KACnB;;IAED;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;;IAGA;QACI;IACJ;;;;IAIA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;IAED;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;KAEA;QACG,cAAc;;IAElB;;;;;IAKA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;;;IAIA;QACI;IACJ;;;IAGA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;;IAGA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;;AAGA,eAAe;AACf;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;;IAGA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA,eAAe;AACf;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;;IAGA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ;;;;;;AAMA,eAAe;AACf;IACI;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;;IAGA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,eAAe;AACf;IACI;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;;;IAIA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;;IAGA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;;;IAGA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf,CAAC,qCAAqC;EACxC;;AAEF;IACI;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;;IAEjB;;;IAGA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB,CAAC,qCAAqC;EACxC;;;AAGF;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;;IAEjB;;;IAGA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB,CAAC,qCAAqC;EACxC;;;;AAIF;IACI;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;;IAEjB;;;IAGA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB,CAAC,qCAAqC;EACxC;;;AAGF;IACI;QACI,eAAe;QACf,OAAO;QACP,SAAS;QACT,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,OAAO;QACP,SAAS;QACT,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,gBAAgB;QAChB,UAAU;QACV,WAAW;IACf;;;;;;IAMA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;;;AAIA;IACI;QACI,eAAe;QACf,OAAO;QACP,SAAS;QACT,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;;;OAGG;;;IAGH;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;;IAGA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;;;AAIA;IACI;QACI,eAAe;QACf,OAAO;QACP,QAAQ;QACR,aAAa;;IAEjB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;;IAElB;IACA;QACI,cAAc;;IAElB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,UAAU;QACV,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;KACnB;;IAED;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;;;IAIA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;IACA;QACI,aAAa;QACb,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,aAAa;QACb,aAAa;QACb,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,aAAa;QACb,YAAY;QACZ;IACJ;;;IAGA;QACI;IACJ;;;;IAIA;QACI,iBAAiB;IACrB;;;;IAIA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;IAED;QACI,iBAAiB;QACjB,gBAAgB;KACnB;;KAEA;QACG,cAAc;;IAElB;;;;;;;IAOA;QACI,eAAe;;;IAGnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;QACf,eAAe;;IAEnB;;IAEA;QACI;IACJ;;;IAGA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;;IAGA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB,EAAE,sCAAsC;EAC5D;;EAEA;IACE,oDAAoD;IACpD,gBAAgB;IAChB,wBAAwB,GAAG,mCAAmC;EAChE,sCAAsC,EAAE,gCAAgC;EACxE;;EAEA;IACE,mDAAmD;IACnD,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,GAAG,kCAAkC;IACzE,UAAU,EAAE,oCAAoC;IAChD,2BAA2B,GAAG,6CAA6C;EAC7E;EACA;IACE,0BAA0B,EAAE,wBAAwB;EACtD;;EAEA;IACE,wBAAwB;IACxB,UAAU,EAAE,iCAAiC;EAC/C;;;EAGA;IACE;QACI,uBAAuB;IAC3B;EACF;;CAED;IACG;QACI,gBAAgB;IACpB;CACH;;CAEA;IACG;QACI,iBAAiB;IACrB;CACH;;;CAGA;IACG;QACI,mBAAmB;IACvB;CACH;;AAED;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;;IAExB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* html, body {margin: 0; height: 100%; overflow: hidden} */\n/* hide body scroll */\n.main{\n    display: flex;\n}\n\n.showtooltip {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 0.3s ease-in-out;\n  }\n  \n  .hidetooltip {\n    visibility: hidden;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    pointer-events: none;\n  }\n  \n.preference-btn {\n    cursor: pointer; \n    padding-top: 4px; \n    padding-bottom: 4px; \n    padding-left: 8px; \n    padding-right: 8px; \n    border: 1px solid #1ccca0;\n    border-radius: 6px; \n    font-weight: 500;\n    color: #000;\n    background: #fff;\n    \n}\n\n.preference-btn:hover {\n    cursor: pointer; \n    color: #fff;\n    background: #047E35;\n    border: none;\n}\n  \n\n.blurhomemain {\n    overflow-x: hidden;\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n    filter: blur(10px);\n    pointer-events: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    \n}\n\n.homemain {\n    overflow-x: hidden;\n    \n}\n\n.showannouncepop {\n    display: default\n}\n\n.hideannouncepop {\n    display: none\n}\n\n.announcepopup1 {\n    background-color: #ffffff; \n    margin: 0px; \n    width: 480px; \n    padding-top: 8px; \n    padding-bottom: 3px; \n    text-align: center;\n}\n\n.announcepopup2 {\n    background-color: #ffffff; \n    margin: 0px; \n    width: 480px; \n    color: #696969; \n    padding-top: 5px; \n    padding-bottom: 3px; \n    text-align: center;\n}\n\n.announcepopup3 {\n    background-color: #ffffff; \n    margin: 0px; \n    width: 480px; \n    color: #000000; \n    padding-top: 5px; \n    padding-bottom: 20px; \n    text-align: center;\n}\n\n.announcepopup4 {\n    width: 480px; \n    height: 400px; \n    margin: 0px; \n    padding: 0px;\n} \n\n\n\n.announcefirst {\n    position: relative;\n}\n\n.AnnouncePopup {\n    position: fixed;\n    top: 8%;\n    left: 35%;\n    z-index: 1050;\n    \n}\n.searchfilter {\n    background-color: #198754;\n    height: 55px;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.searchfilter:hover {\n    background-color: #157347;\n    height: 55px;\n    \n}\n\n.searchfilter:focus {\n    background-color: #157347;\n    height: 55px;\n}\n\n.termsandcondition {\n    cursor: pointer;\n}\n\n.termsandcondition:hover {\n    cursor: pointer;\n    color: #0c5c48;\n}\n\n.accessheaderone {\n    margin-bottom: 20px; \n    font-weight: bold; \n    font-size: 55px; \n    color: #696969;\n}\n\n.accessheaderone::after {\n    content: '';\n    display: block;\n    background-color: #688f82;\n    width: 90px;\n    height: 10px;\n}\n\n.daccessheader {\n    font-weight: bold; \n    color: #696969;\n}\n\n/* .daccessheader::after {\n    content: '';\n    display: block;\n    border: 1px solid #e98181;\n    width: 70px;\n    height: 10px;\n} */\n\n.main-content-container {\n    background-color: #F5F5F5;\n    width: 100%;\n    z-index: 80;    \n}\n\n.servicetagbutton {\n    background-color: #047E35;\n    color: #ffffff;\n    width: 120px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    text-align: center;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.servicetagbutton:hover {\n    background-color: #07aa48;\n    color: #ffffff;\n    width: 120px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    text-align: center;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.text-wrapper {\n    text-align: center;\n    position: relative;\n}\n\n.text-wrapper h3 {\n    font-size: 2.5rem;\n    font-weight: 500;\n    /* margin-top: 2em; */\n}\n\n\n\n.text-wrapper h3 span {\n    color: #156614;\n}\n\n.text-wrapper p {\n    font-size: 1.5rem;\n    font-weight: 400;\n   \n}\n\n\n\n.search-input {\n    height: 55px;\n    padding-left: 20px;\n    border-color: #6FD7AC;\n    text-align: center;\n}\n\n  \n\n.search-input::placeholder {\n    text-align: center;\n}\n\n.search-input:placeholder-shown {\n    text-align: left;\n}\n\n.searchBtn {\n    background-color: #6EA6A9;\n    border-color: #6EA6A9;\n    color: #fff;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-radius: 80px;\n    font-family: 'calibri';\n}\n\n\n\n/* ======== CARD STYLES =============*/\n\n.card-title {\n    position: relative;\n}\n\n.card-title h4 {\n    font-size: 1.5rem;\n    font-weight: 400;\n    width: 8em;\n    text-align: center;\n    margin: 0 auto;\n}\n\n\n\n\n\n.figma-color {\n    background: #B38AF6; \n}\n\n.git-color {\n    background: #9B59B6; \n}\n\n.react-color {\n    background: #56E5FF; \n}\n.flutter-color {\n    background: #005799; \n}\n.elixir-color {\n    background: #705582; \n}\n\n.elixir-color {\n    background: #FF9486; \n}\n\n.csharp-color {\n    background: #A179DC; \n}\n.node-color {\n    background: #83CF27; \n}\n.cypress-color {\n    background: #6FD7AC; \n}\n.prd-color {\n    background: #6EA6A9; \n}\n.dig-color {\n    background: #36528A; \n}\n.manual-color {\n    background: #6B7AFD;\n}\n\n.javascript-color{\n    background: #DAB92D;\n}\n\n.html-color{\n    background: #EF6529;\n}\n\n.analytics-color{\n    background: #27485E;\n}\n\n.findataanalytics-color{\n    background: #4782D9;\n}\n\n.network-color{\n    background: #13A89E;\n}\n\n.python-color{\n    background: #FFDE58;\n}\n\n.sql-color{\n    background: #0078D7;\n}\n\n.django-color{\n    background: #092E20;\n}\n\n.card-title .title-django-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #092E20;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n  \n.card-title .title-sql-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #0078D7;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-python-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #FFDE58;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-findataanalytics-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #4782D9;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-network-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #13A89E;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.datascience-color{\n    background: #7AC0C8;\n} \n \n\n.business-color{\n    background: #558AAA;\n}\n\n.fullstack-color{\n    background: #DADADA;\n}\n\n.photoshop-color{\n    background: #070037;\n}\n\n/* new addition */\n\n.product-manager-training-color{\n    background: #6FD7AC;\n}\n\n.technical-support-specialist-color{\n    background: #6EA6A9;\n}\n\n.comphrensive-seo-specialist-color{\n    background: #36528A;\n}\n\n.comphrensive-community-manager-color{\n    background: #705582;\n}\n\n.cyber-color{\n    background: #2BABE7;\n}\n\n\n.webflow-color{\n    background: #4176CF;\n}\n\n.disablebtn {\n    border: 1px solid #526f8b;\n    background-color: #466a75;\n\n}\n\n.card-title .title-photoshop-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #070037;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n\n\n.card-title .title-fullstack-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #DADADA;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n\n.card-title .title-business-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #558AAA;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-analytics-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #27485E;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-datascience-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #7AC0C8;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n  \n.card-title .title-manual-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #6B7AFD;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-figma-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #B38AF6;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-react-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #56E5FF;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-flutter-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #005799;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-elixir-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #705582;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-csharp-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #A179DC;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-node-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #83CF27;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-cypress-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #6FD7AC;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-prd-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #6EA6A9;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-dig-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #36528A;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n\n.card-title .title-git-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #9B59B6;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-javascript-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #DAB92D;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-html-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #EF6529;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n/* new */\n.card-title .title-webflow-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #4176CF;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n.card-title .title-product-manager-training-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #6FD7AC;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n\n.card-title .title-technical-support-specialist-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #6EA6A9;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-comphrensive-seo-specialist-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #36528A;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-comphrensive-community-manager-rectangle {\n    width: 5.3em;\n    height: 2em;\n    background: #705582;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n    \n}\n\n.card-title .title-cyber-rectangle{\n    width: 5.3em;\n    height: 2em;\n    background: #2BABE7;\n    position: absolute;\n    right: 0;\n    top: -2rem;\n}\n\n/* end */\n\n.card-body p {\n    margin-top: 1em;\n    font-size: 1.25rem;\n}\n\n.card-body .price {\n    font-size: 1.5rem\n}\n\n.card-body .price span {\n    font-size: 3rem;\n}\n\n.course-cards-wrapper {\n    margin-top: 5em;\n}\n\n.start-btn {\n    font-size: 1.5rem;\n    padding: 0.8em 4em;\n    border: none;\n}\n\n.up-card {\n    position: relative;\n    bottom: 5rem;\n}\n\n/* pagination class */\n.prev {\n    border: 1px solid #79bead;\n    font-family: calibri;\n    padding: 7px; \n    margin-right: 10px; \n    border-radius: 10px;\n    color: #79bead;\n    z-index: 43;\n}\n\n.nex { \n    border: 1px solid #79bead;\n    font-family: calibri; \n    padding: 7px; \n    margin-left: 10px; \n    border-radius: 10px;\n    color: #79bead;\n    z-index: 42;\n}\n\n.academystyle {\n    display: flex;\n    flex-direction: column;\n    align-items: center; \n    justify-content: center; \n    vertical-align: middle; \n    margin: auto; \n    position: absolute;\n    top: 0; \n    left: 0;\n    bottom: 0; \n    right: 0;\n    width: 100px;\n    height: 70px;\n}\n\n.academystyle2 {\n    align-items: center; \n    justify-content: center; \n    vertical-align: middle; \n    margin: auto; \n    \n    \n}\n\n\n.prev:hover {\n    background-color: #79bead;\n    color: #fff;\n    border: 1px solid #79bead;\n    cursor: pointer;\n\n    \n}\n\n.nex:hover {\n    background-color: #79bead;\n    color: #fff;\n    border: 1px solid #79bead;\n    cursor: pointer;\n    \n}\n\n.footer {\n    background-color: white;\n    height: 410px;\n\n}\n\n.Naming {\n    color: #156614;\n    font-weight: 800;\n    text-decoration: none;\n}\n\n.socialmed {\n    color: #0c572b;\n}\n\n.socialmed2 {\n    color: #0c572b;\n    cursor: pointer;\n    \n}\n\n/* .Faqtag {\n    margin: 0 auto;\n    text-align: center;\n} */\n\n.faqfill {\n    color: #696969;\n    padding-top: 25px; \n    padding-bottom: 15px; \n    padding-right: 20px; \n    font-size: 17px; \n    font-weight: 500;\n}\n\n.faqfill:hover {\n    background-color: #c4e7b7;\n    color: #fff\n\n}\n\n.Fatag::after {\n    content: '';\n    display: block;\n    background-color: #e98181;\n    width: 50px;\n    height: 10px;\n}\n\n\n.setCenter {\n    margin-top: 110px;\n    margin-left: 80px;\n    margin-right: 40px;\n    \n    \n}\n\n.topbanheight {\n    height: 506px;\n    background-color: #ffffff;\n}\n\n.largebig1 {\n    margin-left: 7px; \n    border-radius: 40px; \n    width: 25px; \n    height: 25px; \n    background-color: #156614\n}\n\n.largebig3 {\n    margin-left: 7px; \n    border-radius: 40px; \n    width: 25px; \n    height: 25px; \n    background-color: #156614\n}\n\n.largebig2 {\n    height: 900px; \n    background-color: #000000\n}\n\n.works1 {\n    margin-right: -100px\n}\n\n.work2 {\n    margin-left: -80px\n}\n\n.works11 {\n   float: right;\n}\n\n.carohei {\n    height: 570px\n}\n\n.carohei2 {\n    height: 700px\n}\n\n.testyspacer22 {\n    margin-top: 50px\n}\n\n\n/* .movementicon {\n    animation: t 13s linear infinite;\n}\n\n@keyframes t {\n    to {\n      transform: translateX(-100%);\n    }\n  } */\n\n\n\n/* .movementicon {\n    animation: linear infinite alternate;\n    animation-name: run;\n    animation-duration: 2s;\n} */\n\n/* @keyframes run {\n    0% {\n      right: 0%;\n      transform: translateX(0);\n    }\n    100% {\n      left: 100%;\n      transform: translateX(-100%);\n      \n    }\n} */\n/* .carousel-control-prev-icon,\n.carousel-control-next-icon {\n  \n  background-color: #79bead;\n  padding: 15px;\n  font-size: 12px;\n  border-radius: 30px;\n  \n} */\n\n.firstherotext {\n    font-weight: Bold; \n    color: #103a0f; \n    /* font-size: 37px;  */\n    font-family: Montserrat;\n}\n\n.secondherotext {\n    margin-top: 7px; \n    margin-bottom: 25px; \n    font-weight: 500; \n    font-size: 24px; \n    color: #092b08; \n    font-family: Montserrat\n}\n\n.thirdherotext {\n    margin-top: 5px; \n    font-weight: 500; \n    font-size: 30px; \n    font-family: Montserrat;\n    color: #092b08; \n}\n\n.herobtn {\n    margin-top: 7px;\n    font-size: 18px; \n    border-radius: 10px; \n    width: 100%; \n    border: 1px solid #156614;\n    height: 52px;\n    color: #047E35;\n}\n\n\n\n.contactusb {\n    margin-top: 7px;\n    background-color: #047E35;\n    font-size: 18px; \n    border-radius: 10px; \n    width: 100%; \n    border: 1px solid #047E35;\n    height: 52px;\n    color: white;\n}\n\n.contactusb:hover {\n    background-color: #37be6d;\n    font-size: 18px; \n    border-radius: 3px; \n    width: 100%; \n    border: 1px solid #2daf2b;\n    height: 52px;\n    color: #ffffff;\n}\n\n.companyi {\n    height: 38px\n}\n\n.taballActive {\n    cursor: pointer; \n    color:#047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold;\n}\n\n.taballInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n.tabsoftwareengineeringActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabsoftwareengineeringInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n\n.tabproductdesignActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabproductdesignInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n.tabdatascienceActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabdatascienceInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n\n.tabsoftwaretestingActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabsoftwaretestingInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n.tabcybersecurityActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabcybersecurityInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n\n.tabmarketingActive {\n    cursor: pointer; \n    color: #047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabmarketingInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n.tabproductmanagementActive {\n    cursor: pointer; \n    color:#047E35; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: bold\n}\n\n.tabproductmanagementInActive {\n    cursor: pointer; \n    padding-top: 6px; \n    padding-bottom: 6px; \n    padding-left: 10px; \n    padding-right: 10px; \n    font-weight: 500\n}\n\n\n/* .testyspacer2 {\n    height: 6px;\n} */\n\n.testlow {\n    height: 200px; \n    background-color: #6EA6A9; \n    border-top-left-radius: 70px;\n}\n\n.testmidlow {\n    position: absolute; \n    z-index: 90; \n    left: 20px; \n    bottom: 50px; \n    height: 150px; \n    width: 340px; \n    background-color: #6EA6A9; \n    border-radius: 85px\n}\n\n.testlow2 {\n    height: 200px; \n    background-color: #83CF27; \n    border-top-left-radius: 70px;\n}\n\n.testmidlow2 {\n    position: absolute; \n    z-index: 90; \n    left: 20px; \n    bottom: 50px; \n    height: 150px; \n    width: 340px; \n    background-color: #83CF27; \n    border-radius: 85px\n}\n\n.testlow3 {\n    height: 200px; \n    background-color: #A179DC; \n    border-top-left-radius: 70px;\n}\n\n.testmidlow3 {\n    position: absolute; \n    z-index: 90; \n    left: 20px; \n    bottom: 50px; \n    height: 150px; \n    width: 340px; \n    background-color: #A179DC; \n    border-radius: 85px\n}\n.testlow4 {\n    height: 200px; \n    background-color: #005799; \n    border-top-left-radius: 70px;\n}\n\n.testmidlow4 {\n    position: absolute; \n    z-index: 90; \n    left: 20px; \n    bottom: 50px; \n    height: 150px; \n    width: 340px; \n    background-color: #005799; \n    border-radius: 85px\n}\n\n.testmid {\n    position: absolute; \n    z-index: 91; \n    right: 0; \n    bottom: 130px; \n    height: 130px; \n    width: 260px; \n    background-color: #ffffff;\n    border-radius: 45px;\n}\n\n.testoc {\n    margin-top: 5px; \n    font-size: 15px; \n    color: #ffffff;\n    font-weight: 500;\n}\n\n.testname {\n    margin-top: 10px; \n    font-weight: 600; \n    font-size: 20px; \n    color: #ffffff;\n}\n\n.testimg {\n    border-radius: 200px; \n    height: 150px; \n    width: 160px; \n    border: 7px solid #ffffff;\n    image-rendering: -moz-crisp-edges;\n    /* Firefox */\n    image-rendering: -o-crisp-edges;\n    /* Opera */\n    image-rendering: -webkit-optimize-contrast;\n    /* Webkit (non-standard naming) */\n    image-rendering: crisp-edges;\n    -ms-interpolation-mode: nearest-neighbor;\n    /* IE (non-standard property) */\n}\n\n\n.test1{\n    height: 70px\n}\n\n.testybio {\n    position: absolute; \n    right: 110px; \n    bottom: 50px; \n    z-index: 92;\n}\n\n\n\n\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000000' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\") !important;\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000000' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\") !important;\n}\n\n\n\n/* disabling Company logo animations */\n/* .movementicon {\n    transform: translate(100%);\n    animation: move 14s linear infinite;\n    margin-left: auto;\n    position: relative;\n    width: 100%;\n    top: 10px;\n    right: 0;\n}\n\n@keyframes move {\n    to {\n      right: 100%;\n      transform: translate(0);\n    }\n  } */\n\n\n  /* add new functions for company logo */\n\n  .movementicon{\n    transition: 0.3s;\n}\n.movementicon:hover {\n    transform: scale(1.2, 1.2);\n    \n}\n\n.achcompany{\n   padding-top: 11px; \n   padding-bottom: 11px; \n   margin-left: 70px;\n}\n\n.howwork {\n    align-items: center; \n    justify-content: center; \n    vertical-align: middle; \n    margin: auto;  \n}\n\n.arrow1 {\n    position: absolute;\n    left: 22%;\n    margin-top: -80px;\n}\n\n.arrow2 {\n    position: absolute;\n    left: 45%;\n    margin-top: -80px;\n}\n\n.arrow3 {\n    position: absolute;\n    left: 68%;\n    margin-top: -80px;\n}\n\n.headmid {\n    height: 100px; \n    background-color: white;\n}\n\n.testyspacer {\n    height: 48px;\n}\n\n.banimgpadsize {\n    margin-left: 10px; \n    margin-right: 20px;\n    position: relative;\n}\n\n.ourIntroVideo {\n    background-color: #696969;\n    height: 60px; \n    width: 80px; \n    border-radius: 10px; \n    cursor: pointer;\n    opacity: 0.85;\n}\n\n.ourIntroVideo:hover {\n    background-color: #696969;\n    height: 60px; \n    width: 80px; \n    border-radius: 10px; \n    cursor: pointer;\n    opacity: 1;\n}\n\n.youtubeintrovideo {\n    position: absolute; \n    right: 40%; \n    top: 49%;\n}\n/* function ends */\n\n.sidebarcourse {\n    /* margin-top: 160px;  */\n    background-color: #F5F5F5;\n}\n\n.sidebarcourse2 {\n    margin-top: 160px; \n   \n}\n\n.sidebarcourse3 {\n    position: absolute;\n    top: 24.8% \n   \n}\n\n.sidebarcourse32 {\n    position: absolute;\n    top: 30% \n   \n}\n.unlocka {\n    margin-bottom: -25px;\n}\n\n.CategoriesTab {\n    display: none;\n}\n\n.showcatalogbox {\n    display: block\n}\n\n.hidecatalogbox {\n    display: none\n}\n\n.catalogshell {\n    z-index: 91;\n    position: fixed; \n    left: 0px; \n    top: 0px; \n    height: 700px; \n    width: 400px; \n    background-color: #ecf8ef;\n}\n\n.hideonfullscreen {\n    display: none;\n}\n\n.servicetag {\n    cursor: pointer; \n    padding-top: 4px; \n    padding-bottom: 4px; \n    padding-left: 7px; \n    padding-right: 7px; \n    border-radius: 30px; \n    font-weight: 500;\n    \n}\n\n.servicetag:hover {\n    cursor: pointer; \n    color: #047E35;\n}\n\n.shiftdownbar {\n    position: absolute; \n    top: 100%;\n}\n\n.AllCshiftdownbar {\n    position: absolute; \n    top: 35%;\n}\n\n.emptyspaces {\n    height: 1680px;\n}\n\n\n.calendly-btn {\n    color: #fff;\n    padding: 10px;\n    background-color: #198754;\n    border: 1px solid rgba(0,0,0,0.2);\n    border-radius: 5px;\n}\n.shownocodebox {\n    display: block\n}\n\n.hidenocodebox {\n    display: none\n}\n\n.nocodedropdown {\n    position: absolute; \n    width: 190px; \n    height: 190px; \n    background-color: #e3f8e7; \n    border: 1px solid #95beb5; \n    border-radius: 10px\n}\n\n.gggettrained {\n    height: 4%;\n}\n\n.gggetjob {\n    height: 1%;\n}\n\n@media (min-width: 297px) and (max-width: 322px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 3%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 302px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 302px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 302px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 302px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggetjob {\n        height: 0%;\n    }\n    .gggettrained {\n        height: 0%;\n    }\n    .emptyspaces {\n        display: none;\n    }\n    /* dropdown menu is \"catalogshell and cataloginnerheight\"*/\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n   \n    .youtubeintrovideo {\n        position: absolute; \n        right: 40%; \n        top: 50%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    .achcompany{\n        padding-top: 11px; \n        padding-bottom: 11px; \n        margin-left: 0px;\n     }\n\n    .testybio {\n        position: absolute; \n        right: 50px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 120px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    \n    .test1{\n        height: 70px\n    }\n\n\n\n    .setCenter {\n        margin-top: 120px;\n    }\n\n    .topbanheight {\n        height: 140vh;\n        \n    }\n\n    .largebig1 {\n        margin-left: 0px; \n        border-radius: 0px; \n        width: 0px; \n        height: 0px; \n    }\n\n    .largebig2 {\n        height: 0px; \n        \n    }\n\n    .works1 {\n        margin-right: 0px\n    }\n\n    .work2 {\n        margin-left: 0px\n    }\n    \n\n    .works11 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n\n    .works22 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n    \n     .carohei {\n        height: 1390px;\n        \n    }\n\n    .carohei2 {\n        height: 1760px;\n        \n    }\n\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .taballActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .taballInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabproductdesignActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabproductdesignInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        border-radius: 30px; \n        font-weight: 500\n    }\n    \n    .tabdatascienceActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabdatascienceInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    \n    .tabsoftwaretestingActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabsoftwaretestingInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabcybersecurityActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        border-radius: 30px;\n        font-weight: Bold\n    }\n    \n    .tabcybersecurityInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n}\n\n@media (min-width: 323px) and (max-width: 385px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 3%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 350px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggetjob {\n        height: 0%;\n    }\n    .gggettrained {\n        height: 0%;\n    }\n    .emptyspaces {\n        display: none;\n    }\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n   \n    .youtubeintrovideo {\n        position: absolute; \n        right: 40%; \n        top: 50%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    .achcompany{\n        padding-top: 11px; \n        padding-bottom: 11px; \n        margin-left: 0px;\n     }\n\n    .testybio {\n        position: absolute; \n        right: 50px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 120px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    \n    .test1{\n        height: 70px\n    }\n\n\n\n    .setCenter {\n        margin-top: 120px;\n    }\n\n    .topbanheight {\n        height: 140vh;\n        \n    }\n\n    .largebig1 {\n        margin-left: 0px; \n        border-radius: 0px; \n        width: 0px; \n        height: 0px; \n    }\n\n    .largebig2 {\n        height: 0px; \n        \n    }\n\n    .works1 {\n        margin-right: 0px\n    }\n\n    .work2 {\n        margin-left: 0px\n    }\n    \n\n    .works11 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n\n    .works22 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n    \n     .carohei {\n        height: 1390px;\n        \n    }\n\n    .carohei2 {\n        height: 1760px;\n        \n    }\n\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .taballActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .taballInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabproductdesignActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabproductdesignInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        border-radius: 30px; \n        font-weight: 500\n    }\n    \n    .tabdatascienceActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabdatascienceInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    \n    .tabsoftwaretestingActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabsoftwaretestingInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabcybersecurityActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        border-radius: 30px;\n        font-weight: Bold\n    }\n    \n    .tabcybersecurityInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n}\n\n\n\n/* function ends */\n\n@media (min-width: 380px) and (max-width: 570px){\n    /* html, body {margin: 0; height: 100%; overflow: hidden} */\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 7%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 350px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 350px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggetjob {\n        height: 0%;\n    }\n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        display: none;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 820px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 560px;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        display: none;\n        margin-top: 0px; \n        background-color: #F5F5F5;\n    }\n\n    .sidebarcourse2 {\n        display: none;\n        margin-top: 0px; \n        \n    }\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 40%; \n        top: 49%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    .achcompany{\n        padding-top: 11px; \n        padding-bottom: 11px; \n        margin-left: 0px;\n     }\n\n    .testybio {\n        position: absolute; \n        right: 50px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 120px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    \n    .test1{\n        height: 70px\n    }\n\n\n\n    .setCenter {\n        margin-top: 120px;\n    }\n\n    .topbanheight {\n        height: 110vh;\n        \n    }\n\n    .largebig1 {\n        margin-left: 0px; \n        border-radius: 0px; \n        width: 0px; \n        height: 0px; \n    }\n\n    .largebig2 {\n        height: 0px; \n        \n    }\n\n    .works1 {\n        margin-right: 0px\n    }\n\n    .work2 {\n        margin-left: 0px\n    }\n    \n\n    .works11 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n\n    .works22 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n    \n     .carohei {\n        height: 1390px;\n        \n    }\n\n    .carohei2 {\n        height: 1690px;\n        \n    }\n\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .taballActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .taballInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabproductdesignActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabproductdesignInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabdatascienceActive {\n        cursor: pointer; \n        color:  #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabdatascienceInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    \n    .tabsoftwaretestingActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabsoftwaretestingInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabcybersecurityActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabcybersecurityInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n}\n\n\n@media (min-width: 532px) and (max-width: 567px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 7%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 450px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 450px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 450px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 450px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggetjob {\n        height: 0%;\n    }\n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        display: none;\n    }\n\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n   \n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 43%; \n        top: 49%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei2 {\n        height: 1400px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    .achcompany{\n        padding-top: 11px; \n        padding-bottom: 11px; \n        margin-left: 0px;\n     }\n\n    .testybio {\n        position: absolute; \n        right: 50px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 120px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    \n    .test1{\n        height: 70px\n    }\n\n\n\n    .setCenter {\n        margin-top: 120px;\n    }\n\n    .topbanheight {\n        height: 130vh;\n        \n    }\n\n    .largebig1 {\n        margin-left: 0px; \n        border-radius: 0px; \n        width: 0px; \n        height: 0px; \n    }\n\n    .largebig2 {\n        height: 0px; \n        \n    }\n\n    .works1 {\n        margin-right: 0px\n    }\n\n    .work2 {\n        margin-left: 0px\n    }\n    \n\n    .works11 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n\n    .works22 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n    \n     .carohei {\n        height: 1390px;\n        \n    }\n\n\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    \n\n    .companyi {\n        height: 20px\n    }\n\n\n    .taballActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .taballInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500;\n    }\n    \n    .tabproductdesignActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabproductdesignInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabdatascienceActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabdatascienceInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    \n    .tabsoftwaretestingActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabsoftwaretestingInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabcybersecurityActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabcybersecurityInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n}\n\n\n/* 90% screen */\n@media (min-width: 1400px) and (max-width: 1590px){\n    .gggetjob {\n        height: 0.4%;\n    }\n    .gggettrained {\n        height: 3.3%;\n    }\n    .nocodedropdown {\n        position: absolute; \n        width: 240px; \n        height: 190px; \n        background-color: #e3f8e7; \n        border: 1px solid #95beb5; \n        border-radius: 10px\n    }\n\n    .sidebarcourse3{\n        position: absolute;\n        top: 22.3% \n    }\n\n    .sidebarcourse32{\n        position: absolute;\n        top: 27.3% \n    }\n    \n    .AllCshiftdownbar {\n        position: absolute; \n        top: 32%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 90%;\n    }\n\n    .youtubeintrovideo {  \n        position: absolute; \n        right: 40%; \n        top: 49%;\n    }\n    \n    .banimgpadsize {\n        margin-left: 40px; \n        margin-right: 100px;\n    }\n    \n\n    .testyspacer {\n        height: 48px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: -80px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: -80px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: -80px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n  \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n   \n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n   \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n  \n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px;  \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    \n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 320px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    .carohei2 {\n        height: 690px\n    }\n    .test1{\n        height: 70px\n    }\n    \n    .testybio {\n        position: absolute; \n        right: 200px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    \n    .largebig1 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 2880px;\n    }\n\n    .largebig3 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 3780px;\n    }\n\n    .largebig2 {\n        width: 4px;\n    }\n}\n\n\n/* 80% screen */\n@media (min-width: 1600px) and (max-width: 1740px){\n    .gggetjob {\n        height: 0%;\n    }\n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .nocodedropdown {\n        position: absolute; \n        width: 240px; \n        height: 190px; \n        background-color: #e3f8e7; \n        border: 1px solid #95beb5; \n        border-radius: 10px\n    }\n\n    .sidebarcourse3{\n        position: absolute;\n        top: 20.3% \n    }\n\n    .sidebarcourse32{\n        position: absolute;\n        top: 24.3% \n    }\n\n    .AllCshiftdownbar {\n        position: absolute; \n        top: 28%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 80%;\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 43%; \n        top: 47%;\n    }\n\n    .banimgpadsize {\n        margin-left: 40px; \n        margin-right: 100px;\n    }\n    \n\n    .testyspacer {\n        height: 23px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: -80px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: -80px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: -80px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n  \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n   \n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n   \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n  \n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px;  \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    \n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 320px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    .carohei2 {\n        height: 630px\n    }\n    .test1{\n        height: 70px\n    }\n    \n    .testybio {\n        position: absolute; \n        right: 200px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    \n    .largebig1 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 2880px;\n    }\n\n    .largebig3 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 3780px;\n    }\n\n    .largebig2 {\n        width: 4px;\n    }\n}\n\n\n\n\n\n/* 75% screen */\n@media (min-width: 1790px) and (max-width: 1890px){\n    .gggetjob {\n        height: 0%;\n    }\n\n    .gggettrained {\n        height: 3.7%;\n    }\n\n    .nocodedropdown {\n        position: absolute; \n        width: 240px; \n        height: 190px; \n        background-color: #e3f8e7; \n        border: 1px solid #95beb5; \n        border-radius: 10px\n    }\n\n    .sidebarcourse3{\n        position: absolute;\n        top: 18.5% \n    }\n\n    .sidebarcourse32{\n        position: absolute;\n        top: 22.7% \n    }\n\n    .AllCshiftdownbar {\n        position: absolute; \n        top: 27%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 75%;\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 43%; \n        top: 47%;\n    }\n\n    .banimgpadsize {\n        margin-left: 40px; \n        margin-right: 100px;\n    }\n    \n\n    .testyspacer {\n        height: 48px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: -80px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: -80px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: -80px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n  \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n   \n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n   \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n  \n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px;  \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    \n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 320px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    .carohei2 {\n        height: 630px\n    }\n    .test1{\n        height: 70px\n    }\n    \n    .testybio {\n        position: absolute; \n        right: 200px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    \n    .largebig1 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 2880px;\n    }\n\n    .largebig3 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 3780px;\n    }\n\n    .largebig2 {\n        width: 4px;\n    }\n}\n\n/* 67% screen */\n@media (min-width: 1900px) and (max-width: 3000px){\n    .jobgget {\n        font-size: 15px;\n    }\n    .gggetjob {\n        height: 0%;\n    }\n    \n    .gggettrained {\n        height: 0%;\n    }\n\n    .nocodedropdown {\n        position: absolute; \n        width: 240px; \n        height: 190px; \n        background-color: #e3f8e7; \n        border: 1px solid #95beb5; \n        border-radius: 10px\n    }\n\n    .sidebarcourse3{\n        position: absolute;\n        top: 17% \n    }\n\n    .sidebarcourse32{\n        position: absolute;\n        top: 20.4% \n    }\n\n    .AllCshiftdownbar {\n        position: absolute; \n        top: 26%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 67%;\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 43%; \n        top: 47%;\n    }\n\n    .banimgpadsize {\n        margin-left: 40px; \n        margin-right: 100px;\n    }    \n\n    .testyspacer {\n        height: 25px;\n    }\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: -80px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: -80px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: -80px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n  \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n   \n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n   \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n  \n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px;  \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    \n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 320px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    .carohei2 {\n        height: 630px\n    }\n    .test1{\n        height: 70px\n    }\n    \n    .testybio {\n        position: absolute; \n        right: 200px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    \n    .largebig1 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 2880px;\n    }\n\n    .largebig3 {\n        margin-left: 13px; \n        border-radius: 40px; \n        width: 35px; \n        height: 35px; \n        background-color: #156614;\n        position: absolute;\n        top: 3780px;\n    }\n\n    .largebig2 {\n        width: 4px;\n    }\n}\n\n\n@media  (min-width: 597px) and (max-width: 870px) {\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        display: none;\n    }\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n    \n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 35%; \n        top: 50%;\n    }\n   \n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei {\n        height: 1490px;\n        \n    }\n\n   \n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }/* your css rules for ipad portrait */\n  }\n\n@media  (min-width: 1470px) and (max-width: 1500px) {\n    .gggettrained {\n        height: 0%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n    \n    .carohei {\n        height: 1690px;\n        \n    }\n\n    .carohei2 {\n        height: 600px;\n        \n    }\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .arrow1 {\n        position: absolute;\n        left: 270px;\n        margin-top: -80px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 570px;\n        margin-top: -80px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 860px;\n        margin-top: -80px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 330px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 330px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 330px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 330px; \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 260px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }/* your css rules for ipad portrait */\n  }\n\n\n@media  (min-width: 1000px) and (max-width: 1150px) {\n    \n    .gggettrained {\n        height: 0%;\n    }\n    \n    .AllCshiftdownbar {\n        position: absolute; \n        top: 48%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 53%;\n    }\n\n    .youtubeintrovideo {\n        position: absolute; \n        right: 38%; \n        top: 49%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .testyspacer {\n        height: 96px;\n    }\n\n    .testybio {\n        position: absolute; \n        left: 20px; \n        bottom: 20px; \n        z-index: 92;\n    }\n    \n\n    .headmid {\n        height: 150px; \n        background-color: white;\n    }\n    .carohei {\n        height: 1690px;\n        \n    }\n\n    .carohei2 {\n        height: 840px;\n        \n    }\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: 0px;  \n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 260px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }/* your css rules for ipad portrait */\n  }\n\n\n\n@media  (min-width: 1160px) and (max-width: 1350px) {\n    .gggettrained {\n        height: 0%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .testyspacer {\n        height: 48px;\n    }\n\n    .testybio {\n        position: absolute; \n        left: 20px; \n        bottom: 20px; \n        z-index: 92;\n    }\n\n    .headmid {\n        height: 120px; \n        background-color: white;\n    }\n    .carohei {\n        height: 1690px;\n        \n    }\n\n    .carohei2 {\n        height: 760px;\n        \n    }\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n\n    \n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 240px; \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 260px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }/* your css rules for ipad portrait */\n  }\n\n\n@media (min-width: 810px) and (max-width: 900px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 20%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 550px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        display: none;\n    }\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei2 {\n        height: 1050px;\n        \n    }\n\n    .testyspacer {\n        height: 95px;\n    }\n    \n    .topbanheight {\n        height: 645px;\n        \n    }\n\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n\n\n    .testybio {\n        position: absolute; \n        right: 60px; \n        bottom: 20px; \n        z-index: 92;\n    }\n    \n    \n    .testlow {\n        height: 220px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 220px; \n        background-color: #83CF27; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px;  \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 220px; \n        background-color: #A179DC; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 220px; \n        background-color: #005799; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 180px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n}\n\n\n@media (min-width: 910px) and (max-width: 997px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 20%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 550px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        height: 1950px;\n    }\n\n    .AllCshiftdownbar {\n        position: absolute; \n        top: 15%;\n    }\n\n    .shiftdownbar {\n        position: absolute; \n        top: 60%;\n    }\n    .bannerpreventpdown {\n        height: 420px;\n    }\n    .youtubeintrovideo {\n        position: absolute; \n        right: 38%; \n        top: 49%;\n    }\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei2 {\n        height: 1000px;\n        \n    }\n\n    .testyspacer {\n        height: 120px;\n    }\n\n    .testybio {\n        position: absolute; \n        right: 60px; \n        bottom: 50px; \n        z-index: 92;\n    }\n    \n    .topbanheight {\n        height: 645px;\n        \n    }\n\n    .arrow1 {\n        position: absolute;\n        left: 22%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 45%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 68%;\n        margin-top: 90px;\n        width: 0px;\n        height: 0px;\n    }\n\n\n    \n    \n    \n    .testlow {\n        height: 220px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 220px; \n        background-color: #83CF27; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px;  \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 220px; \n        background-color: #A179DC; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 220px; \n        background-color: #005799; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 170px; \n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 180px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n}\n\n\n\n@media (min-width: 600px) and (max-width: 800px){ \n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 15%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 550px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 550px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggettrained {\n        height: 0%;\n    }\n    \n    /* .carohei {\n        height: 1690px;\n        \n    } */\n    \n\n    .emptyspaces {\n        display: none;\n    }\n\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n    \n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei2 {\n        height: 1085px;\n        \n    }\n\n    .testyspacer {\n        height: 72px;\n    }\n    \n\n    .testybio {\n        position: absolute; \n        right: 40px; \n        bottom: 20px; \n        z-index: 92;\n    }\n    \n    \n    .testlow {\n        height: 220px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 130px; \n        background-color: #6EA6A9; \n        border-radius: 85px\n    }\n    \n    .testlow2 {\n        height: 220px; \n        background-color: #83CF27; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 130px; \n        background-color: #83CF27; \n        border-radius: 85px\n    }\n    \n    .testlow3 {\n        height: 220px; \n        background-color: #A179DC; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 130px; \n        background-color: #A179DC; \n        border-radius: 85px\n    }\n    .testlow4 {\n        height: 220px; \n        background-color: #005799; \n        border-top-left-radius: 50px;\n    }\n    \n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 50px; \n        bottom: 80px; \n        height: 150px; \n        width: 130px;\n        background-color: #005799; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 170px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n}\n\n\n\n@media (min-width: 100px) and (max-width: 293px){\n    .AnnouncePopup {\n        position: fixed;\n        top: 8%;\n        left: 3%;\n        z-index: 1050;\n        \n    }\n\n    .announcepopup1 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 260px; \n        padding-top: 8px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup2 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 260px; \n        color: #696969; \n        padding-top: 5px; \n        padding-bottom: 3px; \n        text-align: center;\n    }\n    \n    .announcepopup3 {\n        background-color: #ffffff; \n        margin: 0px; \n        width: 260px; \n        color: #000000; \n        padding-top: 5px; \n        padding-bottom: 20px; \n        text-align: center;\n    }\n    \n    .announcepopup4 {\n        width: 260px; \n        height: 400px; \n        margin: 0px; \n        padding: 0px;\n    } \n\n    .gggettrained {\n        height: 0%;\n    }\n\n    .emptyspaces {\n        display: none;\n    }\n\n    .catalogshell {\n        z-index: 91;\n        position: fixed; \n        left: 0px; \n        top: 0px; \n        height: 620px; \n        width: 230px; \n        background-color: #ecf8ef;\n    }\n    .catalogheight{\n        margin-top: 180px\n    }\n\n    .cataloginnerheight {\n        overflow-x: hidden; \n        overflow-y: auto; \n        height: 360px;\n    }\n    .bannerpreventpdown {\n        height: 320px;\n    }\n    .hideonfullscreen {\n        display: block;\n    }\n    .CategoriesTab {\n        display: block;\n    }\n    .unlocka {\n        margin-bottom: 0px;\n    }\n    .sidebarcourse {\n        margin-top: 0px; \n        background-color: #F5F5F5;\n        display: none\n    }\n\n    .sidebarcourse2 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse3 {\n        margin-top: 0px; \n        display: none\n    }\n\n    .sidebarcourse32 {\n        margin-top: 0px; \n        display: none\n    }\n    \n    .unlocka {\n        margin-bottom: 0px;\n    }\n   \n    .youtubeintrovideo {\n        position: absolute; \n        right: 35%; \n        top: 50%;\n    }\n\n    .banimgpadsize {\n        margin-left: 10px; \n        margin-right: 10px;\n    }\n\n    .carohei2 {\n        height: 2195px;\n        \n    }\n    .topbanheight {\n        height: 1145px;\n        \n    }\n    .arrow1 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow2 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    \n    .arrow3 {\n        position: absolute;\n        left: 0px;\n        margin-top: 0px;\n        width: 0px;\n        height: 0px;\n    }\n    .achcompany{\n        padding-top: 11px; \n        padding-bottom: 11px; \n        margin-left: 0px;\n     }\n\n    .testybio {\n        position: absolute; \n        right: 10px; \n        bottom: 40px; \n        z-index: 92;\n    }\n\n    .testlow {\n        height: 200px; \n        background-color: #6EA6A9; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow2 {\n        height: 200px; \n        background-color: #83CF27; \n        border-top-left-radius: 70px;\n    }\n    \n    \n    \n    .testlow3 {\n        height: 200px; \n        background-color: #A179DC; \n        border-top-left-radius: 70px;\n    }\n    .testlow4 {\n        height: 200px; \n        background-color: #005799; \n        border-top-left-radius: 70px;\n    }\n    \n    .testmidlow {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow2 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow3 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n\n    .testmidlow4 {\n        position: absolute; \n        z-index: 90; \n        left: 20px; \n        bottom: 50px; \n        height: 150px; \n        width: 310px; \n        background-color: #0000ff00; \n        border-radius: 85px\n    }\n    \n    .testmid {\n        position: absolute; \n        z-index: 91; \n        right: 0; \n        bottom: 130px; \n        height: 130px; \n        width: 120px; \n        background-color: #ffffff;\n        border-radius: 45px;\n    }\n    \n    .testoc {\n        margin-top: 5px; \n        font-size: 15px; \n        color: #ffffff;\n        font-weight: 500;\n    }\n    \n    .testname {\n        margin-top: 10px; \n        font-weight: 600; \n        font-size: 20px; \n        color: #ffffff;\n    }\n    \n    .testimg {\n        border-radius: 200px; \n        height: 170px; \n        width: 180px; \n        border: 7px solid #ffffff \n    }\n    \n    \n    .test1{\n        height: 70px\n    }\n\n\n\n    .setCenter {\n        margin-top: 120px;\n    }\n\n   \n\n    .largebig1 {\n        margin-left: 0px; \n        border-radius: 0px; \n        width: 0px; \n        height: 0px; \n    }\n\n    .largebig2 {\n        height: 0px; \n        \n    }\n\n    .works1 {\n        margin-right: 0px\n    }\n\n    .work2 {\n        margin-left: 0px\n    }\n    \n\n    .works11 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n\n    .works22 {\n        margin-right: 10%;\n        margin-left: 10%;\n     }\n    \n     .carohei {\n        height: 1390px;\n        \n    }\n\n   \n    \n\n\n\n    .firstherotext {\n        font-size: 27px; \n    \n        \n    }\n    \n    .secondherotext {\n        font-size: 19px; \n        \n    }\n    \n    .thirdherotext {\n        font-size: 19px; \n        \n    }\n    \n    .herobtn {\n        font-size: 17px; \n        \n    }\n\n    .contactusb {\n        margin-top: 7px;\n        font-size: 17px; \n        \n    }\n\n    .companyi {\n        height: 20px\n    }\n\n\n    .taballActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .taballInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabproductdesignActive {\n        cursor: pointer; \n        background-color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabproductdesignInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabdatascienceActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabdatascienceInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    \n    .tabsoftwaretestingActive {\n        cursor: pointer; \n        color: #047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabsoftwaretestingInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n    \n    .tabcybersecurityActive {\n        cursor: pointer; \n        color:#047E35; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: Bold\n    }\n    \n    .tabcybersecurityInActive {\n        cursor: pointer; \n        padding-top: 4px; \n        padding-bottom: 4px; \n        padding-left: 7px; \n        padding-right: 7px; \n        font-weight: 500\n    }\n}\n\n.flip-card {\n    /* Existing styles for the main container */\n    position: relative; /* Required for absolute positioning */\n  }\n  \n  .flip-card-front {\n    /* Existing styles for the front image and content */\n    /* z-index: 1; */\n    transform: rotateY(0deg);  /* Set initial rotation for front */\n  transition: transform 0.5s ease-in-out; /* Add transition for flipping */\n  }\n  \n  .flip-card-back {\n    /* Existing styles for the back image and content */\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transition: opacity 0.5s ease-in-out;  /* Adds smooth transition effect */\n    opacity: 0; /* Initially hide the back content */\n    transform: rotateY(-180deg);  /* Set initial rotation for back (opposite) */\n  }\n  .flip-card:hover .flip-card-front {\n    transform: rotateY(180deg); /* Flip front on hover */\n  }\n  \n  .flip-card:hover .flip-card-back {\n    transform: rotateY(0deg);\n    opacity: 1; /* Reveal back content on hover */\n  }\n \n  \n  @media (max-width: 1200px){\n    .tes {\n        justify-content: center;\n    }\n  }\n  \n @media (max-width: 1150px){\n    .adjust{\n        margin-top: 90px;\n    }\n }\n \n @media (max-width: 999px){\n    .adjust{\n        margin-top: -60px;\n    }\n }\n \n \n @media (max-width: 991px){\n    .adjust{\n        margin-bottom: 90px;\n    }\n }\n\n@media (max-width: 500px){\n    .adjust{\n        margin-bottom: 170px;\n    }\n}\n\n@media (max-width: 455px){\n    .adjust{\n        margin-bottom: 200px;\n    }\n}\n\n@media (max-width:400px){\n    .adjust{\n        margin-bottom: 320px;\n        \n    }\n}\n\n@media (max-width:350px){\n    .adjust{\n        margin-bottom: 450px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
